import { useQuery } from "@tanstack/react-query";
import { type Article, getArticle } from "src/api/articles";
import { articleQueryKeys } from "src/hooks/articleQueryKeys";
import options from "src/hooks/defaultOptions";

export function useArticle(id: number) {
	return useQuery<Article>({
		queryKey: articleQueryKeys.article(id),
		queryFn: () => getArticle(id),
		...options,
		enabled: !!id,
	});
}
